// 创建一个eventBus,音频播放时的通知可用
import Vue from 'vue'
if (!window.audioEventBus) {
  window.audioEventBus = new Vue()
}

// import AudioModel from './audio'
// Vue.component('compile', {
//   props: ['html-data'],
//   render (createElement) {
//     const element = Vue.extend({
//       template: `<div class="compile-box">${this.htmlData}</div>`,
//       components: {
//         AudioModel
//       }
//     })
//     return createElement(element)
//   }
// })
import Content from './Content'
export default Content



// WEBPACK FOOTER //
// ./packages/material-content/src/index.js